export default "__VITE_ASSET__22d7923c__"